<template>
  <div class="my-table managementDetailPage">
    <!-- 面包屑 -->
    <el-card>
      <div class="table-header">
        <div class="left back">
          <img src="@/assets/picture/icon/back_icon.png"/>
          <span>返回</span>
        </div>
      </div>
      <div class="table-header">
        <div class="left">
          <span>当前位置：项目管理/参与的项目/上海仁济医院东院脑神经科A-001</span>
        </div>
      </div>
      <!-- 项目详情 -->
      <el-card class="cardContent">
        <div class="header">
          <span class="subTitle">项目详情</span>
          <div class="fr">
            <div class="flex" v-if="isEditDetail == false">
              <span @click="isEditDetail = false" class="btnTxt">保存</span>
              <span @click="isEditDetail = false" class="btnTxt">取消</span>
            </div>
            <span @click="isEditDetail = true" class="btnTxt">编辑</span>
          </div>
        </div>
        <div class="contentBox">
          <el-form ref="formData" :model="formData" label-width="90px">
            <el-form-item label="项目名称：">
              <span class="txt" v-if="isEditDetail">上海仁济医院东院脑神经科A-001</span>
              <el-input v-else class="w32" v-model="formData.name" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item label="管理员：">
              <span class="txt" v-if="isEditDetail">zhangxiaobei0213</span>
              <el-input v-else v-model="formData.name" placeholder="请输入管理员"></el-input>
            </el-form-item>
            <el-form-item label="项目描述：">
              <span class="txt" v-if="isEditDetail">zhangxiaobei0213</span>
              <el-input v-else type="text"  placeholder="请输入项目描述"  v-model="formData.text"  maxlength="100"  show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <!-- 参与者 -->
      <el-card class="cardContent">
        <div class="header">
          <span class="subTitle">参与者</span>
          <div class="fr">
            <div class="flex">
              <el-input placeholder="请输入用户名" class="mr3">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div class="contentBox">
          <el-tag
            v-for="tag in joinTags"
            :key="tag.name"
            closable
            :disable-transitions="false"
            :type="tag.type">
            {{tag.name}}
          </el-tag>
        </div>
      </el-card>
      <!-- 项目标签 -->
      <el-card class="cardContent">
        <div class="header">
          <span class="subTitle">项目标签</span>
          <div class="fr">
             <div class="flex">
              <el-input v-model="inputValue" class="editInput" placeholder="请输入"></el-input>
              <span @click="handleInputConfirm" class="btnTxt">确认</span>
              <span @click="inputValue = ''" class="btnTxt">取消</span>
            </div>
          </div>
        </div>
        <div class="contentBox">
          <el-tag
            v-for="tag in projectTags"
            :key="tag.name"
            closable
            :disable-transitions="false"
            :type="tag.type">
            {{tag.name}}
          </el-tag>
        </div>
      </el-card>
      <!-- 项目介绍 -->
      <el-card class="cardContent">
        <div class="header">
          <span class="subTitle">项目介绍</span>
          <div class="fr">
            <div class="flex" v-if="isEditIntroduce == false">
              <span @click="isEditIntroduce = false" class="btnTxt">保存</span>
              <span @click="isEditIntroduce = false" class="btnTxt">取消</span>
            </div>
            <span @click="isEditIntroduce = true" class="btnTxt">编辑</span>  
          </div>
        </div>
        <div class="contentBox">
          <el-form ref="formData" :model="formData" label-width="90px">
            <el-form-item label="项目介绍：">
              <span class="txt" v-if="isEditIntroduce">zhangxiaobei0213</span>
              <el-input v-else type="textarea"  placeholder="请输入项目介绍"  v-model="formData.text"  maxlength="100"  show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <!-- 项目资料 -->
      <el-card class="cardContent">
        <div class="header">
          <span class="subTitle">项目资料</span>
          <div class="fr">
            <div class="flex">
              <span class="btnTxt">上传</span>
              <span class="btnTxt">下载</span>
              <span class="btnTxt" >删除</span>
            </div>  
          </div>
        </div>
        <div class="contentBox pt0">
          <div class="selectAll">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <span class="headerTXT">数据量：205个文件</span>
            <span class="headerTXT">占据空间：1.05G</span>
          </div>
          <div class="latticeShow">
            <ul>
              <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                <li ref="boxW" v-for="(item,index) in 20" :key="index" class="flex">
                  <el-checkbox :key="1"></el-checkbox>
                  <img src="@/assets/picture/icon/format/DCM_brain_icon@2x.png" />
                  <div>
                    <p>承蓝项目组人员联系目录</p>
                    <p>由<span>zhangxiaobei0213</span>于<span>2020.12.21 12:25:13</span></p>
                  </div>
                </li>
              </el-checkbox-group>
            </ul>
          </div>
        </div>
      </el-card>
    </el-card>
  </div>
</template>

<script>
  import { formatDate } from "@/plugins/date.js";
  const cityOptions = ['上海', '北京', '广州', '深圳'];
  import qs from 'qs';
  export default {
    data() {
      return {
        multipleSelection: [],
        checkAll: false,
        checkedCities: ['上海', '北京'],
        cities: cityOptions,
        isEditDetail:true,//项目详情是否编辑状态
        isEditIntroduce:true,//项目介绍是否编辑状态
        visibleTitle:'',
        isIndeterminate: true,
        time:'',
        formData:{},//详情参数
        joinTags: [
          { name: '标签一', type: '' },
          { name: '标签二', type: 'success' },
          { name: '标签三', type: 'info' },
          { name: '标签四', type: 'warning' },
          { name: '标签五', type: 'danger' }
        ],//参与者标签
        projectTags: [
          { name: '标签一', type: '' },
          { name: '标签二', type: 'success' },
          { name: '标签三', type: 'info' },
          { name: '标签四', type: 'warning' },
          { name: '标签五', type: 'danger' }
        ],//项目标签
        inputValue:'',//项目标签添加参数
        options:[],//测试数据
        //用于获取数据列表
        queryInfo: {
          cmptName:'',
          endCreateTm:'',
          pageNum:1,
          pageSize: 10,
          productTmplCmptId:'',
          projName:'',
          spvTm:'',
          startCreateTm:'',
          submitterName:'',
          witnCde:'',
          witnType:'',
        },
        dataList: [
          {}
        ],
        total: 0,
      };
    },
    created() {
      this.loadData();
      let boxW = this.$refs.boxW.clientWidth;
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      // 数据加载(监理现场见证记录列表)
      async loadData(){
        let data  = {};
        if(this.queryInfo.submitterName){
          data.submitterName = this.queryInfo.submitterName;
        }else if(this.queryInfo.endCreateTm){
          data.endCreateTm = this.queryInfo.endCreateTm;
        }else if(this.queryInfo.projName){
          data.projName = this.queryInfo.projName;
        }else if(this.queryInfo.startCreateTm){
          data.startCreateTm = this.queryInfo.startCreateTm;
        }else if(this.queryInfo.startCreateTm){
          data.startCreateTm = this.queryInfo.startCreateTm;
        }
        data.pageNum = this.queryInfo.pageNum;
        data.pageSize = this.queryInfo.pageSize;
        const { data: res } = await this.$http.get("/dmp-es-admin/sms/smsWitnRec/witnList?"+qs.stringify(data));
        if(res.code !== 200){
          return this.$message.error(res.message);
        }
        this.dataList = res.data.list;
        this.total = res.data.total;
      },
      // 新增项目标签
      handleInputConfirm(){
        let inputValue = {
          name:this.inputValue,
          type:''
        };
        if (inputValue) {
          this.projectTags.push(inputValue);
        }
        this.inputValue = '';
      },
      // 全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleCheckAllChange(val) {
        this.checkedCities = val ? cityOptions : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.cities.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
    },
  };
</script>

<style lang="less" scoped>
  .managementDetailPage{
    .back{
      margin-bottom: 2.4rem;
      img{
        width: 1.8rem;
        height: 1.8rem;
        margin-right: 0.7rem;
      }
      span{    
        font-size: 1.6rem;
        font-weight: 400;
        color: #333333;
      }
    }
    .cardContent{
      padding:2.1rem 2.1rem 3rem 2.1rem;   
      border: 1px solid #F4F4F4;
      box-shadow: 0rem 0rem 2rem 0rem rgba(202, 204, 204, 0.3);
      border-radius: 1rem;
      .header{
        padding-bottom: 2rem;
        border-bottom: 1px solid #CBCBCB;
        /deep/ .el-input__inner{
          border:1px solid #C0C0C0;
          border-right:none;
          height: 100%;
        }
        /deep/ .el-input-group{
          width: 32rem;
          height: 3rem;
        }
        /deep/ .el-input-group__append{
          border:1px solid #C0C0C0;
          border-left:none;
          padding:0;
          background: #fff;
        }
        /deep/ .el-input-group__append button.el-button{
          padding:0;
          width: auto;
          margin-right: 1.1rem;
        }
        .editInput{
          /deep/ .el-input__inner{
            width: 16rem;
            height: 2.4rem;
          }
        }
        .btnTxt{          
          font-size: 1.4rem;
          font-weight: 400;
          color: #1B3B7C;
          margin-right: 2rem;
          width: 4rem;
          cursor: pointer;
        }
        .btnTxt:last-of-type{
          margin-right: 0;
        }
        .subTitle:before{
          content:'';
          display: inline-block;
          width: 0.3rem;
          height: 1.5rem;
          background: #1B3B7C;
          border-radius: 5px;
          margin-right: 1rem;
        }
        .subTitle{         
          font-size: 1.6rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
      }
      .pt0{
        padding-top: 0 !important;
      }
      .contentBox{
          padding-top:2.9rem;
          .w32{
            width: 32rem;
          }
          /deep/ .el-form-item{
            margin-bottom: 0rem;
            .el-form-item__label{
              color:#666;
              font-size: 1.4rem;
            }
          }
          /deep/ .el-input__inner{
            height: 3rem;
          }
          .txt{            
            font-size: 1.4rem;
            font-weight: 400;
            color: #333;
            line-height: 4rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          /deep/ .el-tag{
            /*padding:0.5rem 1.2rem;*/
            border-radius: 5px;
            border:1px solid #999;
            font-size: 1.4rem;
            color:#333;
            background: #fff !important;
            margin-right: 2.4rem;
            height: 1.3rem;
            display: initial;
            .el-tag__close{
              color:#D3D3D3 !important;
            }
          }
          .selectAll{
            padding:3.7rem 3rem 1.7rem 3rem;
            border-bottom: 1px solid #eee;
            .headerTXT:first-of-type{
              margin-left:2.8rem;
            };
            .headerTXT{
              font-size: 1.4rem;
              color: #999;
              margin-right: 3.1rem;
            }
          }
          .latticeShow{
            ul{
              li:hover{
                background:#DAE4F9;
              };
              li:nth-of-type(4n){
                margin-right: 0;
              }
              li{
                margin-bottom: 2rem;
                width: 22%;
                float: left;
                padding:1rem;
                cursor: pointer;
                border-radius: 10px;
                background: #F4F4F4;
                margin-right: 4%;
                .el-checkbox{
                  display: block;
                }
                img{
                  width: 4.8rem;
                  height: 3.9rem;
                  margin:0 1rem;
                }
                p:first-of-type{
                  font-size: 1.4rem;
                  font-weight: 400;
                  color: #333333;
                  line-height: 2.1rem;
                }
                p:nth-of-type(2){
                  font-size: 1.2rem;
                  font-weight: 400;
                  color: #999;
                  line-height: 2.1rem;
                  span{
                    color:#666;
                    margin:0 0.5rem;
                  }
                }
              }
            }
          }
        }
    }
  }
</style>
